'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

export interface MarathiMatrimonyFaq {
  question: string;
  answer: string;
}

interface MarathiMatrimonyClientProps {
  faqs: MarathiMatrimonyFaq[];
}

const communityServices: { label: string; href?: string }[] = [
  { label: "Marathi Matrimony India" },
  { label: "Marathi Matrimony Sites" },
  { label: "Marathi Marriage Sites" },
  { label: "Marathi Matrimony App" },
  { label: "Marathi Matrimony Fees" },
  { label: "Marathi Matrimony Pune" },
  { label: "Marathi Matrimony Search" },
  { label: "Marathi Matrimony Girl Image" },
  { label: "Best Marathi Matrimony Sites" },
  { label: "Beautiful Marathi Matrimony Girl" },
  { label: "Top 10 Marathi Matrimony Sites" },
  { label: "Marathi Matrimony Free Registration" },
  { label: "Marathi Matrimony Girl Profile" },
  { label: "Marathi Matrimony Girl" },
  { label: "Marathi Matrimony Belgaum" },
  { label: "Marathi Matrimony Mumbai" },
  { label: "Second Marriage Marathi Matrimony" },
  { label: "Marathi Matrimony Bangalore" },
  { label: "Marathi Matrimony Reviews" },
  { label: "Marathi Matrimonial" },
  { label: "Marathi Matrimonial Sites" },
  { label: "Free Marathi Matrimonial Sites" },
  { label: "Marathi Matrimonial Site" },
  { label: "Marathi Matrimonial Website" },
  { label: "Marathi Matrimonial Sites in Pune" },
  { label: "Marathi Matrimonial Sites in Mumbai" },
  { label: "Best Marathi Matrimonial Sites" },
  { label: "All Marathi Matrimonial Sites" },
  { label: "ZEE Marathi Matrimonial Site" },
  { label: "List of Marathi Matrimonial Sites" },
  { label: "Marathi Matrimonial Sites for Second Marriage" },
  { label: "Free Marathi Matrimonial" },
  { label: "Top Marathi Matrimonial Sites in India" },
  { label: "Marathi Matrimonial Brides" },
  { label: "Marathi Matrimonial Biodata" },
  { label: "Marathi Matrimonial site in Mumbai" },
  { label: "Best Marathi Matrimonial site" },
  { label: "Marathi Marriage Biodata" },
  { label: "Marathi Marriage Biodata word format download free" },
  { label: "Marathi Marriage" },
  { label: "Marathi Marriage Bureau" },
  { label: "Marathi Marriage Bureau Mumbai" },
  { label: "Marathi Marriage Bureau in Vadodara" },
  { label: "Marathi Marriage bureau near me" },
  { label: "Free Marathi Marriage bureau" },
  { label: "Marathi Marriage bureau in Indore" },
  { label: "Marathi marriage bureau in Ahmedabad" },
  { label: "Marathi marriage bureau in Hyderabad" },
  { label: "Marathi Marriage bureau in Pune" },
  { label: "Marathi marriage bureau Pune" },
  { label: "Marathi marriage bureau website" },
  { label: "Marathi marriage bureau in Bangalore" },
  { label: "Marathi marriage bureau in Mumbai" },
  { label: "Best Marathi marriage bureau in Mumbai" },
  { label: "Marathi Vivah" },
  { label: "Marathi Vivah Mandal" },
  { label: "Marathi Vivah Sanstha" },
  { label: "Marathi Vivah Mandal in Mumbai" },
  { label: "ZEE Marathi Vivah registration" },
  { label: "ZEE Marathi Vivah Sanstha" },
  { label: "Marathi Vivah Sanstha Pune" },
  { label: "Marathi Vadhu Pahije" },
  { label: "Marathi Lagna Biodata" },
  { label: "Marathi Lagna Sanstha" },
];

export default function MarathiMatrimony({ faqs }: MarathiMatrimonyClientProps) {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Matrimony for Marathi Communities"
        items={communityServices}
      />

    </div>
  );
}

